//----- Component --------------------------------------------------------/
// Developer :  Daiana Curcio / Nicolas pascucci
// Creation Date :13/06/2024
// Version : 1
// Description : Cambio de punto de venta
//------Changes ----------------------------------------------------------//
// Change Date : 08/04/2026
// Change by : Joaquin Baldellou
// Change description: Diseño responsive, mejoras visuales, optimización de código, manejo de errores y notificaciones.
// Change Date :
// Change by :
// Change description:
//========================================================================/
import React, { useState, useEffect } from "react";
import { UrlApi } from "../../../services/apirest";
import {
  Container,
  Typography,
  Box,
  TextField,
  IconButton,
  Button,
  Autocomplete,
  Stack,
  Divider,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import PersonIcon from "@mui/icons-material/Person";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import { logEventos } from "../../../services/services";
//notificacion
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const PRIMARY = "#1F618D";
const PRIMARY_LIGHT = "#2980B9";

const InfoField = ({ label, value, accentColor }) => (
  <Box sx={{ mb: 1 }}>
    <Typography
      variant="caption"
      sx={{
        color: accentColor || PRIMARY,
        fontWeight: 600,
        letterSpacing: 0.5,
        textTransform: "uppercase",
        fontSize: "0.68rem",
      }}
    >
      {label}
    </Typography>
    <Typography
      variant="body2"
      sx={{
        mt: 0.2,
        px: 1.5,
        py: 0.5,
        backgroundColor: "#EAF2FB",
        borderRadius: 1.5,
        color: "#2C3E50",
        fontWeight: 500,
        border: "1px solid #D6EAF8",
        minHeight: 30,
        display: "flex",
        alignItems: "center",
      }}
    >
      {value || (
        <span style={{ color: "#AAB7B8", fontStyle: "italic" }}>
          Sin asignar
        </span>
      )}
    </Typography>
  </Box>
);

const ChoferCard = ({
  title,
  accentColor,
  options,
  onChange,
  seleccionado,
  showEmpty,
}) => (
  <Card
    elevation={0}
    sx={{
      minWidth: 280,
      maxWidth: 320,
      flex: 1,
      borderRadius: 3,
      border: `1.5px solid ${accentColor}30`,
      boxShadow: `0 4px 20px ${accentColor}18`,
      overflow: "visible",
    }}
  >
    <Box
      sx={{
        background: `linear-gradient(135deg, ${accentColor} 0%, ${accentColor}CC 100%)`,
        borderRadius: "12px 12px 0 0",
        py: 1,
        px: 2,
        display: "flex",
        alignItems: "center",
        gap: 1,
      }}
    >
      <PersonIcon sx={{ color: "#fff", fontSize: 20 }} />
      <Typography
        variant="subtitle1"
        sx={{ color: "#fff", fontWeight: 700, letterSpacing: 0.3 }}
      >
        {title}
      </Typography>
    </Box>
    <CardContent sx={{ pt: 1.5, pb: "12px !important" }}>
      <Autocomplete
        disabled={!options}
        size="small"
        focused
        disableClearable
        noOptionsText={"Chofer INEXISTENTE"}
        options={options || []}
        value={seleccionado || null}
        autoHighlight
        getOptionLabel={(opt) => opt.username || ""}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        onChange={(event, value) => onChange(value)}
        renderOption={(props, option) => (
          <Box component="li" key={option.id} {...props}>
            {option.username}
          </Box>
        )}
        renderInput={(params) => (
          <TextField
            style={{ backgroundColor: "#ffffff", width: "100%" }}
            required
            focused
            size="small"
            placeholder="Tipee para buscar..."
            {...params}
            label="Chofer"
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 2,
                "&.Mui-focused fieldset": { borderColor: accentColor },
              },
              "& label.Mui-focused": { color: accentColor },
            }}
            inputProps={{ ...params.inputProps }}
          />
        )}
      />

      {seleccionado && seleccionado.id ? (
        <Box sx={{ mt: 1.5 }}>
          <Divider sx={{ mb: 1.5, borderColor: `${accentColor}30` }} />
          <InfoField
            label="Código"
            value={seleccionado.id}
            accentColor={accentColor}
          />
          <InfoField
            label="Nombre y Apellido"
            value={seleccionado.nombre_apellido}
            accentColor={accentColor}
          />
          <InfoField
            label="N° Punto de Venta Hipergas"
            value={seleccionado.pto_vta_hipergas}
            accentColor={accentColor}
          />
          <InfoField
            label="N° Punto de Venta Autogas"
            value={seleccionado.pto_vta_autogas}
            accentColor={accentColor}
          />
          <InfoField
            label="Caja Mercado Pago"
            value={seleccionado.caja_mercadolibre}
            accentColor={accentColor}
          />
        </Box>
      ) : (
        showEmpty && (
          <Box sx={{ mt: 1.5, textAlign: "center", py: 1.5, color: "#AAB7B8" }}>
            <PersonIcon sx={{ fontSize: 36, opacity: 0.3 }} />
            <Typography variant="caption" display="block" sx={{ mt: 0.5 }}>
              Seleccioná un chofer
            </Typography>
          </Box>
        )
      )}
    </CardContent>
  </Card>
);

function CambioPtoVenta(props) {
  const [disBtn, setDisBtn] = useState(false);
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");

  const [chofer, setChofer] = useState();
  const [choferSeleccionado, setChoferSeleccionado] = useState(null);

  const obtenerChoferesXusername = () => {
    fetch(UrlApi + "/choferes/activoXusername")
      .then((data) => data.json())
      .then((data) => setChofer(data));
  };
  useEffect(() => {
    obtenerChoferesXusername();
  }, []);

  const [choferCambio, setChoferCambio] = useState();
  const [choferSeleccionadoCambio, setChoferSeleccionadoCambio] =
    useState(null);

  const obtenerChoferesCambio = () => {
    fetch(UrlApi + "/choferes/cambioXusername")
      .then((data) => data.json())
      .then((data) => setChoferCambio(data));
  };
  useEffect(() => {
    obtenerChoferesCambio();
  }, []);

  const cajaATransferir = choferSeleccionadoCambio?.caja_mercadolibre || null;
  const cajaReceptor = choferSeleccionado?.caja_mercadolibre || null;

  const handleClose = () => {
    props.cambio(false);
    props.tabla(true);
  };

  const guardarCambio = async (e) => {
    logEventos(
      "Guardar cambio de punto de venta",
      "puntos de venta",
      "Se guardo el cambio de punto de venta",
      localStorage.getItem("user"),
    );
    e.preventDefault();
    const body = {
      pto_vta_hipergas: choferSeleccionadoCambio.pto_vta_hipergas,
      pto_vta_autogas: choferSeleccionadoCambio.pto_vta_autogas,
      usuario: localStorage.getItem("user"),
    };
    // Si el chofer que cede tiene caja MP, se traspasa (reemplaza la del receptor).
    // Si no tiene, el receptor conserva la suya.
    if (cajaATransferir) {
      body.caja_mercadolibre = cajaATransferir;
    }
    await fetch(UrlApi + "/choferes/" + choferSeleccionado.id, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    })
      .then((res) => {
        if (!res.err) {
          setOpenSnack(true);
          setColorMensaje("#D4EFDF");
          setMensaje(
            cajaATransferir
              ? `Se guardó exitosamente ! Caja Mercado Pago ${cajaATransferir} transferida.`
              : "Se guardó exitosamente !",
          );
        } else {
          setOpenSnack(false);
          setColorMensaje("#F1948A");
          setMensaje("Error al guardar");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  useEffect(() => {
    if (!choferSeleccionado || !choferSeleccionadoCambio) {
      setDisBtn(true);
    } else {
      setDisBtn(false);
    }
  }, [choferSeleccionado, choferSeleccionadoCambio]);

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") return;
    setOpenSnack(false);
    handleClose();
  };

  return (
    <Container maxWidth="lg">
      {/* Header */}

      <Box
        sx={{
          background: `linear-gradient(135deg, ${PRIMARY} 0%, ${PRIMARY_LIGHT} 100%)`,
          borderRadius: "0 0 20px 20px",
          px: 2,
          py: 1,
          display: "flex",
          alignItems: "center",
          boxShadow: "0 4px 16px rgba(31,97,141,0.25)",
        }}
      >
        <IconButton onClick={handleClose} sx={{ color: "#fff", mr: 1 }}>
          <ArrowBackIcon />
        </IconButton>
        <SwapHorizIcon sx={{ color: "#fff", mr: 1, fontSize: 26 }} />
        <Typography
          variant="h6"
          sx={{ color: "#fff", fontWeight: 700, letterSpacing: 0.5 }}
        >
          Cambiar Punto de Venta
        </Typography>
      </Box>
      <Box
        sx={{
          backgroundColor: "#F8F9F9",
          px: 2,
          py: 2,
          borderRadius: 3,
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <form onSubmit={guardarCambio} autoComplete="off">
          {/* Cards row */}
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              alignItems: { xs: "stretch", md: "flex-start" },
              justifyContent: "center",
              gap: 1.5,
            }}
          >
            <ChoferCard
              title="Del Chofer"
              accentColor="#1A7E5A"
              options={choferCambio}
              onChange={setChoferSeleccionadoCambio}
              seleccionado={choferSeleccionadoCambio}
              showEmpty
            />

            {/* Arrow */}
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "row", md: "column" },
                justifyContent: "center",
                alignItems: "center",
                alignSelf: "center",
                minWidth: 60,
              }}
            >
              <Box
                sx={{
                  width: 46,
                  height: 46,
                  borderRadius: "50%",
                  background: `linear-gradient(135deg, ${PRIMARY} 0%, ${PRIMARY_LIGHT} 100%)`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 4px 14px rgba(31,97,141,0.3)",
                }}
              >
                {/* En mobile las cards se apilan, la flecha apunta hacia abajo */}
                <ArrowForwardIcon
                  sx={{
                    color: "#fff",
                    fontSize: 26,
                    transform: { xs: "rotate(90deg)", md: "none" },
                  }}
                />
              </Box>
            </Box>

            <ChoferCard
              title="Al Chofer"
              accentColor={PRIMARY}
              options={chofer}
              onChange={setChoferSeleccionado}
              seleccionado={choferSeleccionado}
              showEmpty
            />
          </Box>

          {/* Aviso traspaso caja Mercado Pago */}
          {choferSeleccionado && choferSeleccionadoCambio && (
            <MuiAlert severity={cajaATransferir ? "warning" : "info"} sx={{ mt: 1.5, borderRadius: 2 }}>
              {cajaATransferir ? (
                <>
                  También se transferirá la caja Mercado Pago <strong>{cajaATransferir}</strong> de{" "}
                  <strong>{choferSeleccionadoCambio.username}</strong> a{" "}
                  <strong>{choferSeleccionado.username}</strong>.
                  {cajaReceptor && cajaReceptor !== cajaATransferir && (
                    <>
                      {" "}{choferSeleccionado.username} perderá su caja actual{" "}
                      <strong>{cajaReceptor}</strong>, que quedará libre.
                    </>
                  )}
                </>
              ) : (
                <>
                  {choferSeleccionadoCambio.username} no tiene caja Mercado Pago asignada.{" "}
                  {choferSeleccionado.username} conservará su caja actual
                  {cajaReceptor ? <> (<strong>{cajaReceptor}</strong>)</> : " (sin asignar)"}.
                </>
              )}
            </MuiAlert>
          )}

          {/* Action buttons */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mt: 1.5,
              mb: 4,
              px: { xs: 0, md: 1 },
            }}
          >
            <Button
              variant="outlined"
              onClick={handleClose}
              color="error"
              sx={{ borderRadius: 2, px: 3, fontWeight: 600 }}
            >
              Volver
            </Button>
            <Button
              disabled={disBtn}
              variant="contained"
              type="submit"
              sx={{
                borderRadius: 2,
                px: 3,
                fontWeight: 600,
                background: disBtn
                  ? undefined
                  : `linear-gradient(135deg, #1A7E5A 0%, #27AE60 100%)`,
                boxShadow: disBtn
                  ? undefined
                  : "0 4px 14px rgba(26,126,90,0.35)",
                "&:hover": {
                  background: `linear-gradient(135deg, #166344 0%, #219150 100%)`,
                },
              }}
            >
              Guardar Cambio
            </Button>
          </Box>
        </form>
      </Box>
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
      <br />
    </Container>
  );
}

export default CambioPtoVenta;
